export default "/images/4523f6312a1387f5f8c20e86a416fc24.avif";